export default {
  GET_REGISTERS: (state) => state.registers,

  GET_TOTAL: (state) => state.total,

  GET_SELECTED_REGISTER: (state) => state.selectedRegister,
  
  GET_REGISTERS_BY_FACILITY: (state) => (facilityId) => {
    return state.registers.filter(r => 
      r.facilityId === facilityId || r.facilityGroupId === facilityId
    );
  },
  
  GET_USER_REGISTERS: (state) => (userId) => {
    return state.registers.filter(r => 
      r.assignedUsers && r.assignedUsers.includes(userId)
    );
  },
  
  GET_LOADING: (state) => state.loading,
  
  GET_UPDATE_LOADING: (state) => state.updateLoading,
  
  GET_UPLOAD_PROGRESS: (state) => state.uploadProgress,
  
  GET_UPLOAD_STATUS: (state) => state.uploadStatus,
  
  GET_VALIDATION_RESULTS: (state) => state.validationResults,
  
  GET_VALIDATION_SUMMARY: (state) => {
    if (!state.validationResults) return null;
    return {
      total: state.validationResults.totalRows,
      valid: state.validationResults.validRows,
      invalid: state.validationResults.invalidRows,
      errors: state.validationResults.validationResults
        .filter(r => r.status === 'Invalid')
    };
  },
  
  GET_IMPORT_RESULTS: (state) => state.importResults,
  
  GET_TEMPLATES: (state) => state.templates,
  
  GET_CURRENT_MAPPING: (state) => state.currentMapping,
  
  GET_FACILITIES: (state) => state.facilities,
  
  GET_USERS: (state) => state.users,
  
  GET_ERROR: (state) => state.error,

  GET_OPTIONS: (state) => state.options,

  // ==========================================
  // AUDIT LOG GETTERS
  // ==========================================

  GET_AUDIT_LOGS: (state) => state.auditLogs,

  GET_AUDIT_LOGS_TOTAL: (state) => state.auditLogsTotal,

  GET_AUDIT_LOGS_LOADING: (state) => state.auditLogsLoading,

  GET_AUDIT_LOG_DETAIL: (state) => state.auditLogDetail,

  GET_AUDIT_LOG_DETAIL_LOADING: (state) => state.auditLogDetailLoading,

  GET_AUDIT_SIDEBAR_OPEN: (state) => state.auditSidebarOpen,

  GET_AUDIT_SIDEBAR_MODE: (state) => state.auditSidebarMode,

  GET_SELECTED_ROW_FOR_AUDIT: (state) => state.selectedRowForAudit,

  GET_AUDIT_VIEW_MODE: (state) => state.auditViewMode,

  GET_AUDIT_FILTERS: (state) => state.auditFilters,

  /**
   * Get audit logs grouped by date (for timeline display)
   */
  GET_AUDIT_LOGS_BY_DATE: (state) => {
    const groups = {};
    state.auditLogs.forEach(log => {
      const date = new Date(log.actionTimestamp).toLocaleDateString();
      if (!groups[date]) {
        groups[date] = [];
      }
      groups[date].push(log);
    });
    return groups;
  },

  /**
   * Get audit log statistics
   */
  GET_AUDIT_LOG_STATS: (state) => {
    const stats = {
      total: state.auditLogsTotal,
      byActionType: {},
      byUser: {}
    };

    state.auditLogs.forEach(log => {
      // Count by action type
      if (!stats.byActionType[log.actionType]) {
        stats.byActionType[log.actionType] = 0;
      }
      stats.byActionType[log.actionType]++;

      // Count by user
      const userName = log.userName || 'Unknown';
      if (!stats.byUser[userName]) {
        stats.byUser[userName] = 0;
      }
      stats.byUser[userName]++;
    });

    return stats;
  },

  /**
   * Check if audit sidebar is in row mode
   */
  IS_AUDIT_ROW_MODE: (state) => state.auditSidebarMode === 'row',

  /**
   * Check if audit sidebar is in register mode
   */
  IS_AUDIT_REGISTER_MODE: (state) => state.auditSidebarMode === 'register',

  /**
   * Get pagination info for audit logs
   */
  GET_AUDIT_PAGINATION: (state) => ({
    page: state.auditFilters.page,
    itemsPerPage: state.auditFilters.itemsPerPage,
    total: state.auditLogsTotal,
    pageCount: Math.ceil(state.auditLogsTotal / state.auditFilters.itemsPerPage)
  }),

  // ==========================================
  // API DATA SOURCE GETTERS
  // ==========================================

  GET_API_DATA_SOURCES: (state) => state.apiDataSources,

  GET_API_DATA_SOURCES_TOTAL: (state) => state.apiDataSourcesTotal,

  GET_SELECTED_API_DATA_SOURCE: (state) => state.selectedApiDataSource,

  GET_API_DATA_SOURCE_LOADING: (state) => state.apiDataSourceLoading,

  GET_API_DATA_SOURCES_BY_REGISTER: (state) => (registerId) => {
    return state.apiDataSources.filter(ds => ds.registerId === registerId);
  },

  GET_API_WIZARD_OPEN: (state) => state.apiWizardOpen,

  GET_API_WIZARD_STEP: (state) => state.apiWizardStep,

  GET_API_WIZARD_MODE: (state) => state.apiWizardMode,

  GET_API_WIZARD_CONFIG: (state) => state.apiWizardConfig,

  GET_API_WIZARD_TEST_RESULT: (state) => state.apiWizardTestResult,

  GET_API_WIZARD_PREVIEW_DATA: (state) => state.apiWizardPreviewData,

  GET_API_WIZARD_MAPPING: (state) => state.apiWizardMapping,

  GET_API_WIZARD_SCHEDULE: (state) => state.apiWizardSchedule,

  GET_EXECUTION_HISTORY: (state) => state.executionHistory,

  GET_EXECUTION_HISTORY_TOTAL: (state) => state.executionHistoryTotal,

  GET_EXECUTION_HISTORY_LOADING: (state) => state.executionHistoryLoading,
};